import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-8',
  templateUrl: './8.component.html',
  styleUrls: ['./8.component.scss'],
})
export class CuiGeneral8Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
